import { registerTermUIElement } from "../src";
import "../src/style.css";
import { mountApp } from "./app";

registerTermUIElement();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root");
}

const dispose = mountApp(root);

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    dispose();
  });
}
